import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@src/redux/store';
import { User } from '@src/types/user';
import { getAdminList } from './projectThunk';

const adminListAdapter = createEntityAdapter<User>({
  selectId: (adminUser) => adminUser.id,
});

const adminListSlice = createSlice({
  name: 'adminList',
  initialState: adminListAdapter.getInitialState({ loading: false }),
  reducers: {},
  extraReducers: ({ addCase }) => {
    addCase(getAdminList.pending, (state) => {
      state.loading = true;
    })
      .addCase(getAdminList.fulfilled, (state, { payload }) => {
        state.loading = false;
        const { ids, entities } = adminListAdapter.addMany(state, payload);

        state.ids = ids;
        state.entities = entities;
      })
      .addCase(getAdminList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default adminListSlice.reducer;

export const adminListSelector = (state: RootState) => state.adminList;
